import { render, staticRenderFns } from "./uploading-images-to-server.vue?vue&type=template&id=4d968618&"
import script from "./uploading-images-to-server.vue?vue&type=script&lang=ts&"
export * from "./uploading-images-to-server.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports